import React from 'react';
import Link from 'gatsby-link';

import config from '../utils/config';
import PageTitle from '../components/PageTitle';

const handleSubmit = (e) => {
    e.preventDefault();

    let textInputValue = document.getElementById("name").value;
    let messageInputValue = document.getElementById("message").value;
    let phoneInputValue = document.getElementById("phone").value;

    console.log(textInputValue);
    console.log(messageInputValue);
    console.log(phoneInputValue);

    var xhr = new XMLHttpRequest();
    xhr.open("POST", "https://3jdtraap46.execute-api.us-east-1.amazonaws.com/Beta/comments", true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.send(JSON.stringify({
        name: textInputValue,
        message: messageInputValue,
        phone: phoneInputValue
    }));
    document.getElementById("commentsForm").reset();
};

const Contact = () => (
  <div className="wpforms-container-full">
    <PageTitle title="Contact" />
    <p> Leave us a message below. If you want us to videochat you, please also leave a phone number!</p>
    <form onSubmit={handleSubmit} id="commentsForm" className="wpforms-form">
      <input placeholder="Your name"  id="name" /><br/>
      <input placeholder="Phone number" id="phone" /><br/>
        <textarea placeholder="Message" id="message" rows="4" cols="30" /><br/>
      <button>Send</button>
    </form>
  </div>
);

export default Contact;



// WEBPACK FOOTER //
// ./src/pages/contact.js